var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    { attrs: { hasData: true, loading: _vm.processing } },
    [
      _c(
        "div",
        {
          staticClass:
            "px-4 py-2 leading-5 text-gray-700 hover:bg-cool-gray-200 hover:text-gray-900 focus:outline-none select-none",
          class: `${_vm.read ? "opacity-50 hover:opacity-100" : ""}`,
        },
        [
          _c("div", { staticClass: "mb-1" }, [
            _c(
              "div",
              { staticClass: "float-right text-gray-300 ml-1" },
              [
                !_vm.read
                  ? _c("UIButton", {
                      staticClass: "bg-gray-100",
                      attrs: {
                        variant: "outline",
                        size: "exs",
                        buttonText: "Mark as read",
                      },
                      on: { click: _vm.markNotificationAsRead },
                    })
                  : _c("UIButton", {
                      staticClass: "bg-gray-100",
                      attrs: {
                        variant: "danger",
                        size: "exs",
                        buttonText: "Remove",
                      },
                      on: { click: _vm.deleteNotification },
                    }),
              ],
              1
            ),
            _vm._v(" " + _vm._s(_vm.message) + " "),
          ]),
          _c("div", { staticClass: "flex justify-between" }, [
            _c("span", [
              _vm.link
                ? _c(
                    "a",
                    {
                      staticClass:
                        "text-primary-500 hover:underline text-sm hover:cursor-pointer",
                      attrs: { href: "#" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.openLink.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("Open page")]
                  )
                : _vm._e(),
            ]),
            _c(
              "time",
              { staticClass: "text-xs", attrs: { datetime: _vm.datetime } },
              [_vm._v(" " + _vm._s(_vm.formattedData) + " ")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }